@if (matrix) {
    <div
        class="matrix"
        [ngStyle]="{ width: matrix.impactSize * (cellSize + cellSpacing * 2) + 50 + 'px' }"
    >
        <div class="left-legend">
            <div class="title">
                <span>{{ "likelihoodTitle" | t }}</span>
            </div>
            <div class="measures">
                @for (y of matrix.matrix | keyvalue; track y) {
                    <div
                        class="point"
                        [ngStyle]="{
                            'grid-row': matrix.likelihoodSize - y.key,
                            height: cellSize + 'px',
                            margin: cellSpacing + 'px 0',
                        }"
                        [title]="matrix.likelihoodInfo ? matrix.likelihoodInfo[y.key].Name : ''"
                    >
                        {{ +y.key + 1 }}
                    </div>
                }
            </div>
        </div>
        <div class="risk-matrix">
            @for (y of matrix.matrix | keyvalue; track y) {
                @for (x of y.value | keyvalue; track x) {
                    <div
                        class="scale"
                        [ngStyle]="{
                            'background-color': matrix.colors[x.value],
                            'grid-row': matrix.likelihoodSize - y.key,
                            'grid-column': x.key + 1,
                            height: cellSize + 'px',
                            width: cellSize + 'px',
                            margin: cellSpacing + 'px',
                        }"
                        (click)="matrixCellClick(y.key, x.key, matrix.colors[x.value])"
                        [class.selected]="
                            highlightSelection &&
                            selected &&
                            selected.Likelihood == y.key &&
                            selected.Impact == x.key
                        "
                        [class.outline-border-top]="
                            borderTopCells && borderTopCells[y.key + '-' + x.key]
                        "
                        [class.outline-border-right]="
                            borderRightCells && borderRightCells[y.key + '-' + x.key]
                        "
                        [title]="
                            (matrix.likelihoodInfo
                                ? ('likelihoodTooltip'
                                  | t: { name: matrix.likelihoodInfo[y.key].Name })
                                : '') +
                            (matrix.impactInfo
                                ? (matrix.likelihoodInfo ? '\n' : '') +
                                  ('impactTooltip'
                                      | t: { name: matrix.impactInfo[x.key].Name })
                                : '')
                        "
                    >
                        @if (
                            matrix.matrixContent &&
                            matrix.matrixContent.length > 0 &&
                            matrix.matrixContent[y.key][x.key]
                        ) {
                            <div class="cell-value">
                                <span>{{ matrix.matrixContent[y.key][x.key] }}</span>
                            </div>
                        }
                    </div>
                }
            }
        </div>
        <div class="bottom-legend">
            <div class="measures">
                @for (x of matrix.matrix[0] | keyvalue; track x) {
                    <div
                        class="point"
                        [title]="matrix.impactInfo ? matrix.impactInfo[x.key].Name : ''"
                    >
                        {{ +x.key + 1 }}
                    </div>
                }
            </div>
            <div class="title">
                {{
                    matrix.customImpactName
                        ? matrix.customImpactName
                        : ("impactTitle" | t)
                }}
            </div>
        </div>
    </div>
}
